<template>
  <div :tabindex="tabindex" @blur="open = false">
    <div class="multiselect filter-form-box languageSelectBox">
      <div class="selectBox">
        <span class="header-text">Approved Languages</span>
        <div
          class="fakeclass cursor-pointer d-block"
          :class="{
            open: open,
            'select-arrow': this.path,
            'select-arrow2': !this.path,
            input: true,
            'is-danger': errors.first('additionalLanguages')
          }"
          :state="!errors.has('additionalLanguages')"
          @click="toggleOpen"
        >
          <span v-if="this.selectedLanguages && this.selectedLanguages.length">
            <span v-if="this.selectedLanguages.length == 1">
              {{ this.selectedLanguages[0].display_name }}
            </span>
            <span v-else>
              Selected
              <span class="number-badge">{{ this.selectedLanguages.length }}</span>
            </span>
          </span>
          <span v-else>
            Select language(s)
          </span>
        </div>
        <span v-show="errors.has('additionalLanguages')" class="error-style">Approved languages are required.</span>
        <div class="overSelect"></div>
      </div>
      <div class="select-scroll activity-builder-select-options showCheckboxesLanguage" :class="{ selectHide: !open }" v-if="isDisplayApprovedLanguageCheckBoxes">
        <div class="check_label_input d-flex custom-control custom-checkbox" v-for="(language, i) of languageList" :key="i" @click="selectLanguage(language)">
          <input class="custom-control-input" type="checkbox" :value="language" v-model="selectedLanguages" />
          <input class="custom-control-input" v-validate="selectedLanguageOption.length == 0 ? 'required' : ''" type="checkbox" :value="language" v-model="selectedLanguages" name="additionalLanguages" />
          <label class="custom-control-label checkbox-label">{{ language.display_name }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "approved-language-select",
  props: {
    options: {
      required: true
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    },
    countryId: {
      required: true
    },
    path: {
      type: Boolean
    },
    additionalApprovedLanguage: {
      type: Array
    },
    updateParentOpen: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      selectedLanguages: [],
      languageList: [],
      previousCountryId: null,
      isDisplayApprovedLanguageCheckBoxes: false,
      selectedLanguageName: "English (US)",
      open: false,
      selectedLanguageOption: []
    };
  },
  mounted() {
    // this.selectedLanguageOption = this.additionalApprovedLanguage;
    if (this.countryId) {
      this.isDisplayApprovedLanguageCheckBoxes = true;
    }
    this.languageList = this.options;
    this.selectedLanguages = this.additionalApprovedLanguage;
  },
  watch: {
    countryId: function(newValue, oldvalue) {
      this.previousCountryId = oldvalue;
      this.selectedLanguages = [];
    },
    options: {
      handler: function(newvalue) {
        this.isDisplayApprovedLanguageCheckBoxes = true;
        this.selectedLanguages = [];
        this.languageList = newvalue;
        const defaultLanguage = newvalue ? newvalue.find(e => e.is_default === true) : [];
        if (!!defaultLanguage && defaultLanguage.length > 0) {
          this.selectLanguage(defaultLanguage);
        }
      }
    },
    additionalApprovedLanguage: {
      deep: true,
      handler: function(value) {
        this.selectedLanguages = value;
      }
    }
  },
  methods: {
    toggleOpen() {
      this.open = !this.open;
    },
    selectLanguage(language) {
      this.selectedLanguageOption = language;
      this.displayLanguageCount();
      this.$emit("additionalLanguage", {
        selectedLanguage: this.selectedLanguages,
        countryId: this.countryId,
        previousCountryId: this.previousCountryId
      });
    },
    displayLanguageCount() {
      const optionIndex = this.selectedLanguages.findIndex(lang => lang.language_id === this.selectedLanguageOption.language_id);
      if (optionIndex === -1) {
        this.selectedLanguages.push(this.selectedLanguageOption);
      } else {
        this.selectedLanguages.splice(optionIndex, 1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.selectHide {
  display: none;
}

.languageSelectBox {
  position: relative;
}
.check_label_input input {
  float: left;
  line-height: 30px;
  margin-top: 8px;
  -webkit-margin-before: 8px;
}
.showCheckboxesLanguage {
  /* display: none; */
  background: #fff;
  position: absolute;
  width: 100% !important;
  height: auto;
  max-height: 250px;
  border-radius: 3px;
  padding: 10px;
  overflow: scroll;
  z-index: 3;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
}
.filter-form-box .select-scroll::-webkit-scrollbar {
  width: 8px; /* width of the entire scrollbar */
}
.filter-form-box .select-scroll::-webkit-scrollbar-track {
  background: transparent; /* color of the tracking area */
}
.filter-form-box .select-scroll::-webkit-scrollbar-thumb {
  background-color: #b0bac9; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
  border: 3px solid transparent; /* creates padding around scroll thumb */
}
.select-scroll {
  scrollbar-width: thin; /* "auto" or "thin"  */
  scrollbar-color: #e6e9ed transparent; /* scroll thumb & track */
}
.select-arrow2 {
  background: url("/static/img/arrow-down.png") no-repeat bottom 6px right 18px transparent !important;
}
.select-arrow {
  background: url("/static/img/required.svg") no-repeat right, url("/static/img/arrow-down.png") no-repeat bottom 6px right 18px #f5f8fa !important;
}
.filter-form-box select {
  width: 100%;
  font-size: 12px;
  height: 40px;
  border-radius: 3px;
  background-color: #f5f8fa;
  color: #666669;
  border: solid 1px #ced4da;
}
.checkbox-label {
  padding-top: 2.8px;
}
.fakeclass {
  padding: 8px 10px 7px 8px;
  border-radius: 4px;
  border: solid 1px #d3dfe4;
}
.number-badge {
  width: 18px;
  height: 20px;
  flex-grow: 0;
  margin: 0 0 0 5px;
  padding: 0 5px;
  border-radius: 4px;
  background-color: #e0e0e0;
  color: #4c8ce4;
}
.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}
</style>
